import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import React from "react";
import { connect } from "react-redux";
import { Doughnut } from "react-chartjs-2";
import { instance } from "../../../../../Actions/AxiosInstance";
import DefaultProfileImage from "../../../../../Assets/Images/profile_defaultImg.svg";
import leaves from "../../../../../Assets/Icons/Leaves/leaves-16px.svg";
import LabelIcon from "../../../../../Component/Labels/LabelIcon";
import ProfilePictureSmall from "../../../../../Component/Thumbnail/ProfilePictureSmall";
import DynamicForm from "../../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../../Component/DynamicForm/Fields/Select";
import { getFormattedDate } from "../../../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  drawerPaper: {
    width: "30%",
  },
});

class LeaveDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      open: false,
      firstName: "",
      lastName: "",
      emailId: "",
      DrawerOpen: false,
      right: false,
      upcomingLeaves: [],
      unplannedname: [],
      unplannedcount: [],
      plannedcount: [],
      plannedname: [],
      businessunitid: null,
      officeaddressid: null,
      departmentid: null,
      OfficeLocationList: [],
      departmentList: [],
      businessUnits: [],
      absents: [],
    };

    this.selectType = this.selectType.bind(this);
  }

  componentDidMount() {
    this.getLongLeaves();
    this.GetOfficeLocationList();
    this.GetBusinessUnits();
    this.GetDepartmentList();
  }

  GetOfficeLocationList() {
    const data = {
      featurekey: "leaveBalanceAndHistory",
      subscriptionid: this.props.AuthenticationAction.login.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        const OfficeLocationList = [];
        OfficeLocationList.push(
          { displayname: "Select Company Location", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ OfficeLocationList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetBusinessUnits() {
    const data = {
      featurekey: "leaveBalanceAndHistory",
    };
    instance
      .post("subscription/allbusinessunit", data)
      .then((result) => {
        const businessUnits = [];
        businessUnits.push(
          { displayname: "Select Business Unit", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ businessUnits });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetDepartmentList() {
    const data = {
      featurekey: "leaveBalanceAndHistory",
    };
    instance
      .post(`subscription/alldepartment`, data)
      .then((result) => {
        const departmentList = [];
        departmentList.push(
          { displayname: "Select Department", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ departmentList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getLeaveBreakDown() {
    const data = {
      businessunitid: this.state.businessunitid,
      departmentid: this.state.departmentid,
      officeaddressid: this.state.officeaddressid,
    };

    instance
      .post("trackdashboard/leavetakenbreakdown", data)
      .then((result) => {
        const planned = [
          ...(result.data.result[0].planned && result.data.result[0].planned),
        ];
        const unplanned = [
          ...(result.data.result[0].unplanned &&
            result.data.result[0].unplanned),
        ];
        const plannedname = planned.map((plan) => plan.fullname);
        const plannedcount = planned.map((plan) => plan.leaverequestcount);
        const unplannedname = unplanned.map((plan) => plan.fullname);
        const unplannedcount = unplanned.map((plan) => plan.leaverequestcount);
        this.setState({
          plannedcount,
          plannedname,
          unplannedcount,
          unplannedname,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  selectType(name, id) {
    if (name == "businessunitid") {
      this.setState(
        {
          [name]: id,
          officeaddressid: null,
          departmentid: null,
        },
        () => {
          this.getLeaveBreakDown();
        },
      );
    } else if (name == "officeaddressid") {
      this.setState(
        {
          [name]: id,
          businessunitid: null,
          departmentid: null,
        },
        () => {
          this.getLeaveBreakDown();
        },
      );
    } else {
      this.setState(
        {
          [name]: id,
          officeaddressid: null,
          businessunitid: null,
        },
        () => {
          this.getLeaveBreakDown();
        },
      );
    }
  }

  getLongLeaves() {
    instance
      .post("trackdashboard/upcominglongleaveemployee")
      .then((result) => {
        this.setState({
          upcomingLeaves: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    return (
      <div className="content-outer-wrapper-with-tab">
                <Helmet>
          <title>{headersList.Leave.Dashboard.header}</title>
        </Helmet>
        <Grid container>
          <Grid
            item
            xs={12}
            md={8}
            sm={12}
            style={{ padding: "0px 16px 0px 0px" }}
          >
            <div className="margin-bottom-24">
              <LabelIcon label="Leaves taken breakdown" img={leaves} />
              <Paper
                style={{
                  height: 250,
                }}
              >
                <div style={{ padding: 16 }}>
                  <Grid container className="margin-top-20">
                    <Grid
                      item
                      xs={12}
                      md={4}
                      sm={12}
                      className="padding-left-16"
                    >
                      <div className="margin-bottom-16">
                        <DynamicForm
                          fields={selectinputconverter({
                            value: this.state.businessunitid,
                            options: this.state.businessUnits,
                            placeholder: "Business unit",
                          })}
                          onChange={(id) =>
                            this.selectType("businessunitid", id)
                          }
                        />
                      </div>
                      <div className="margin-bottom-16">
                        <DynamicForm
                          fields={selectinputconverter({
                            value: this.state.departmentid,
                            options: this.state.departmentList,
                            placeholder: "Department",
                          })}
                          onChange={(id) => this.selectType("departmentid", id)}
                        />
                      </div>
                      <div className="margin-bottom-16">
                        <DynamicForm
                          fields={selectinputconverter({
                            value: this.state.officeaddressid,
                            options: this.state.OfficeLocationList,
                            placeholder: "Location",
                          })}
                          onChange={(id) =>
                            this.selectType("officeaddressid", id)
                          }
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4} sm={12}>
                      <div className="leaves-breakdown-chart">
                        <Doughnut
                          data={{
                            labels: this.state.plannedname,
                            datasets: [
                              {
                                label: "Planned leaves",
                                data: this.state.plannedcount,
                                backgroundColor: [
                                  "#f7b596",
                                  "#b596f7",
                                  "#f7dc96",
                                  "#96acf7",
                                  "#96f7df",
                                  "#f7dc96",
                                  "#d0f796",
                                  "#e0f7fa",
                                  "#eceff1",
                                  "#efebe9",
                                  "#d7ccc8",
                                  "#cfd8dc",
                                  "#e3f2fd",
                                  "#fff9c4",
                                  "#b2dfdb",
                                  "#c8e6c9",
                                  "#e0e0e0",
                                  "#ffe0b2",
                                  "#f3e5f5",
                                ],
                              },
                            ],
                          }}
                          width="150px"
                          height="100px"
                          options={{
                            rotation: 100,
                            animation: {
                              animateRotate: true,
                            },
                            tooltips: {
                              footerFontSize: 16,
                              titleFontSize: 16,
                              bodyFontSize: 16,
                            },
                            title: {
                              display: true,
                              text: "Planned leaves",
                              position: "top",
                              fontSize: 14,
                            },
                            legend: {
                              display: false,
                              position: "bottom",
                              fullWidth: false,
                            },
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4} sm={12}>
                      <div className="leaves-breakdown-chart">
                        <Doughnut
                          data={{
                            labels: this.state.unplannedname,
                            datasets: [
                              {
                                label: "Unplanned leaves",
                                data: this.state.unplannedcount,
                                backgroundColor: [
                                  "#f7b596",
                                  "#b596f7",
                                  "#f7dc96",
                                  "#96acf7",
                                  "#96f7df",
                                  "#f7dc96",
                                  "#d0f796",
                                  "#e0f7fa",
                                  "#eceff1",
                                  "#efebe9",
                                  "#d7ccc8",
                                  "#cfd8dc",
                                  "#e3f2fd",
                                  "#fff9c4",
                                  "#b2dfdb",
                                  "#c8e6c9",
                                  "#e0e0e0",
                                  "#ffe0b2",
                                  "#f3e5f5",
                                ],
                              },
                            ],
                          }}
                          width="150px"
                          height="100px"
                          options={{
                            rotation: 100,
                            animation: {
                              animateRotate: true,
                            },
                            tooltips: {
                              footerFontSize: 16,
                              titleFontSize: 16,
                              bodyFontSize: 16,
                            },
                            title: {
                              display: true,
                              text: "Unplanned leaves",
                              position: "top",
                              fontSize: 14,
                            },
                            legend: {
                              display: false,
                              position: "bottom",
                              fullWidth: false,
                            },
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            {this.state.upcomingLeaves.length > 0 && (
              <div className="margin-bottom-24">
                <LabelIcon label="Upcoming long leaves" img={leaves} />
                <Paper
                  className="padding16 thin-scroll"
                  style={{
                    height: 220,
                    overflowY: "auto",
                    position: "relative",
                  }}
                >
                  {this.state.upcomingLeaves.length > 0 ? (
                    this.state.upcomingLeaves.map((leaves) => (
                      <Grid
                        container
                        style={{
                          borderBottom: "1px solid #edf5fd",
                          paddingBottom: 4,
                        }}
                      >
                        <Grid item xs={12} md={1} sm={12}>
                          <p className="t-12 margin-top-2">🏖</p>
                        </Grid>
                        <Grid item xs={12} md={11} sm={12}>
                          <p className="small-dark-secondary t-bold">
                            {leaves.fullname}
                          </p>
                          <p className="extra-small-dark-disabled">
                            {leaves.fromdatetime &&
                              getFormattedDate(leaves.fromdatetime)}
                            {" - "}
                            {leaves.todatetime &&
                              getFormattedDate(leaves.todatetime)}
                          </p>
                        </Grid>
                      </Grid>
                    ))
                  ) : (
                    <div className="text-align-center margin-top-30">
                      No records found
                    </div>
                  )}
                </Paper>
              </div>
            )}
          </Grid>
        </Grid>

        {/* <Grid container>

          <Grid item xs={12} md={4} sm={12} style={{ padding: "0px 12px 0px 24px" }}>
            <div className="margin-bottom-24">
              <LabelIcon label="Highest excess leaves" img={leaves} />
              <Paper
                className="padding16"
                style={{
                  height: 168,
                  position: "relative",
                }}
              >
                <Grid container style={{ borderBottom: "1px solid #edf5fd", paddingBottom: 4 }}>
                  <Grid item xs={12} md={2} sm={12}>
                    <ProfilePictureSmall src={DefaultProfileImage} />
                  </Grid>
                  <Grid item xs={12} md={6} sm={12}>
                    <p className="small-dark-secondary t-bold">Priti Varma </p>
                    <p className="extra-small-dark-disabled">2yrs work anniversary</p>
                  </Grid>
                  <Grid item xs={12} md={4} sm={12}>
                    <p className="small-dark-secondary text-align-right">6 excess</p>
                  </Grid>
                </Grid>
              </Paper>
            </div>
          </Grid>
        </Grid> */}
      </div>
    );
  }
}

LeaveDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(LeaveDashboard)),
);
